import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import style from "./AddNewCustomer.module.css";
import { Toaster, toast } from "react-hot-toast";

import style2 from "../../../Components/support/customervendor/Customer.module.css";
import {
  a1,
  a173,
  a18,
  a189,
  a190,
  a20,
  a207,
  a21,
  a210,
  a213,
  a22,
  a23,
  a27,
  a28,
  a36,
  a37,
  a4,
  a40,
  a704,
  a706,
  a710,
  a89,
  a90,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { allStateList } from "../../Api/StateList";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import AlertMessage from "../../Other Functions/AlertMessage";
import { allCountriesList } from "../../Api/CountriesAllList";
import { Grid, TextField } from "@mui/material";

import Customertable from "Components/support/customervendor/customer";
// import DragAndDrop from "Components/Other Functions/DragAndDrop";
import { useRef } from "react";
import { duration } from "moment";
import { a128 } from "Components/Api/RootApiPath1";

import verifyGST from "services/gstService";
import { createEinvoiceAndWayBill } from "services/verification";

export default function AddCustomerNew() {
  const [active, setActive] = useState("AddNew");
  const [allCustomersData, setAllCustomersData] = useState([]);
  const [countryStates, setCountryStates] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [customerSlabList, setCustomerSlabList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [customerRateOfInterestList, setCustomerRateOfInterestList] = useState(
    []
  );

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);
  const inputRef23 = useRef(null);
  const inputRef24 = useRef(null);
  const inputRef25 = useRef(null);
  const inputRef26 = useRef(null);
  const inputRef27 = useRef(null);

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  const [selectedDate, setSelectedDate] = useState("");

  const [customerCreditPeriodList, setCustomerCreditPeriodList] = useState([]);

  const [profilefields, setProfilefields] = useState([
    { key: "code", name: "client code" },
    { key: "companyname", name: "company name" },
    { key: "customername", name: "customer name" },
    { key: "email", name: "email" },
    { key: "mobile", name: "mobile" },
    { key: "aadhar", name: "aadhar" },
    { key: "pan", name: "pan" },
    { key: "gstnumber", name: "gst" },
  ]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
  };

  const [addressfields, setAddressfields] = useState([
    { key: "code", name: "client code" },
    { key: "companyname", name: "company name" },
    { key: "customername", name: "customer name" },
    { key: "email", name: "email" },
    { key: "mobile", name: "mobile" },
    { key: "aadhar", name: "aadhar" },
    { key: "pan", name: "pan" },
    { key: "gstnumber", name: "gst" },
  ]);
  const [accountfields, setAccountfields] = useState([
    { key: "code", name: "client code" },
    { key: "companyname", name: "company name" },
    { key: "customername", name: "customer name" },
    { key: "email", name: "email" },
    { key: "mobile", name: "mobile" },
    { key: "aadhar", name: "aadhar" },
    { key: "pan", name: "pan" },
    { key: "gstnumber", name: "gst" },
  ]);

  const [newCs, setNewCs] = useState({
    FirstName: "",
    LastName: "",
    MiddleName: "",
    PerAddStreet: "",
    CurrAddStreet: "",
    Area: "",
    Mobile: "",
    Email: "",
    Password: "",
    CustomerLoginId: "",
    DateOfBirth: "",
    PerAddPincode: "",
    Gender: "",
    CustomerSlabId: 0,
    CreditPeriodId: 0,
    RateOfInterestId: 0,
    OnlineStatus: "",
    PerAddTown: "",
    City: "",
    Area: "",
    CurrAddPincode: "",
    CurrAddState: "",
    PerAddTown: "",
    PerAddState: "",
    Country: "India",
    PerAddCountry: "India",
    GstNo: "",
    PanNo: "",
    AadharNo: "",
    BalanceAmount: "0",
    AdvanceAmount: "0",
    Discount: "0",
    CreditPeriod: "0",
    FineGold: "0",
    FineSilver: "0",
    Remark: "",
    VendorId: 0,
    AddToVendor: false,
    oldEntry: false,
  });
  const allStates = useSelector((state) => state);

  
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const adminState = adminLoggedIn?.Clients?.State;
  console.log(adminLoggedIn);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const openView = params.get("openView");
  const csName = params.get("csName");
  const states = {
    US: ["California", "Texas", "Florida", "New York"],
    IN: allStateList,
  };
  const csMobile = params.get("csMobile");
  const csAddress = params.get("csAddress");



  useEffect(() => {
    window.scroll(0, 0);
    if (openView == "addNew") {
      setActive("AddNew");
      document
        .getElementById("adminAddCustomerTitle")
        .classList.add("activeCategoryTitle");
      document
        .getElementById("adminAddCustomerLogo")
        .classList.add("activeCategoryLogo");
      document.getElementById("adminAddCustomerTitle").click();
      setNewCs({
        ...newCs,
        FirstName: csName,
        Mobile: csMobile,
        PerAddStreet: csAddress,
        CurrAddStreet: csAddress,
      });
    }
  }, []);

  const fetchAllCustomers = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a706, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCustomersData(data);
      } else {
        setActive("addNew");
        document
          .getElementById("adminAddCustomerTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("adminAddCustomerLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("adminAddCustomerTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCustomers(); // Ensure this is not called repeatedly
  }, []); // Add an empty dependency array to prevent infinite calls

  const fetchAllCustomersSlab = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a207, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();

    try {
      if (data.length > 0) {
        setCustomerSlabList(data);
      } else {
        alert("Please Add Customers Slab First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersSlab();
  }, []);

  const fetchAllCustomersRateOfInterest = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a210, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();

    try {
      if (data.length > 0) {
        setCustomerRateOfInterestList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersRateOfInterest();
  }, []);

  const fetchAllCustomersCreditPeriod = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a213, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();

    try {
      if (data.length > 0) {
        setCustomerCreditPeriodList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersCreditPeriod();
  }, []);
  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCustomersData.find((x) => x.Id === id);
    setEditedData(selectedItem);
  };

  const handleSaveClick = () => {
    handleSubmit();

    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (gstValid === false) {
      toast.error("Cannot submit form. Invalid GST number.");
      return;
    }
    try {
      const response = await fetch(a40, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();

      setNewCs({
        FirstName: "",
        LastName: "",
        MiddleName: "",
        PerAddStreet: "",
        CurrAddStreet: "",
        Area: "",
        Mobile: "",
        Email: "",
        Password: "",
        CustomerLoginId: "",
        DateOfBirth: "",
        PerAddPincode: "",
        Gender: "",
        CustomerSlabId: 0,
        CreditPeriodId: 0,
        RateOfInterestId: 0,
        OnlineStatus: "",
        City: "",
        PerAddTown: "",
        CurrAddPincode: "",
        CurrAddState: "",
        PerAddTown: "",
        PerAddState: "",
        Country: "",
        PerAddCountry: "",
        AadharNo: "",
        Discount: "0",
        CreditPeriod: "0",
        PanNo: "",
        FineGold: "0",
        FineSilver: "0",
        GstNo: "",
        ClientCode: clientCode,
        VendorId: newCs.VendorId,
        Remark: newCs.Remark,
        AddToVendor: newCs.AddToVendor === "false",

        Id: newCs.oldEntry ? newCs.Id : 0,
      });
      fetchAllCustomers();
    } catch (error) {
      console.error(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
    setNewCs({ ...newCs, [name]: value });
  };

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProductsList();
    if (newCs.PerAddCountry == "India") {
      setCountryStates(states.IN);
    }
  }, []);

  // const handleNewCsChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name == "Country" && value == "India") {
  //     setCountryStates(states.IN);
  //     setNewCs({ ...newCs, Country: value, State: "" });
  //   } else if (name == "Country" && value == "United States") {
  //     setCountryStates(states.US);
  //     setNewCs({ ...newCs, Country: value, State: "" });
  //   }

  //   else {
  //     setNewCs({ ...newCs, [name]: value });
  //     setCountryStates([]);
  //   }
  //   if (name == "AddToVendor") {
  //     if (!newCs.oldEntry) {
  //       setNewCs({ ...newCs, [name]: value });
  //     } else {
  //       // setMessageType("error");
  //       toast.error("Kindly Change it from Settings", {
  //         duration: 3000,
  //         position: "top-center",
  //       });
  //       setShowError(true);
  //     }
  //   } else {
  //     setNewCs({ ...newCs, [name]: value });
  //   }
  // };

  const handleNewCsChange = (e) => {
    const { name, value } = e.target;

    if (name === "Country") {
      let updatedStates = [];
      if (value === "India") {
        updatedStates = states.IN; // Set states for India
      } else if (value === "United States") {
        updatedStates = states.US; // Set states for the US
      }
      setCountryStates(updatedStates);
      setNewCs((prev) => ({
        ...prev,
        Country: value,
        CurrAddState: "", // Reset state field when the country changes
      }));
    } else if (name === "CurrAddState") {
      setNewCs((prev) => ({
        ...prev,
        CurrAddState: value, // Update the selected state
      }));
    } else if (name === "AddToVendor") {
      if (!newCs.oldEntry) {
        setNewCs((prev) => ({
          ...prev,
          [name]: value,
        }));
      } else {
        toast.error("Kindly Change it from Settings", {
          duration: 3000,
          position: "top-center",
        });
        setShowError(true);
      }
    } else if (name === "GstNo") {
      const filteredValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 15);

      setNewCs((prev) => ({
        ...prev,
        GstNo: filteredValue,
      }));

      if (!filteredValue) {
        setGstValid(null);
        setIsGstActive(true);
      }
    } else {
      setNewCs((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const addnewCs = async (e) => {
    e.preventDefault();
    if (gstValid === false) {
      toast.error("Cannot submit form. Invalid GST number.");
      return;
    }
    setLoading(true);
    const formData = {
      FirstName: newCs.FirstName,
      MiddleName: newCs.MiddleName,
      LastName: newCs.LastName,
      Email: newCs.Email !== "" ? newCs.Email : `${newCs.Mobile}@example.com`,
      CustomerLoginId:
        newCs.CustomerLoginId !== ""
          ? newCs.CustomerLoginId
          : `${newCs.Mobile}@example.com`,
      Password: newCs.Password,
      Gender: newCs.Gender,
      CustomerSlabId: parseInt(newCs.CustomerSlabId),
      CreditPeriodId: parseInt(newCs.CreditPeriodId),
      RateOfInterestId: parseInt(newCs.RateOfInterestId),
      Mobile: newCs.Mobile,
      OnlineStatus: newCs.OnlineStatus !== "" ? newCs.OnlineStatus : "Active",
      DateOfBirth: newCs.DateOfBirth,
      AdvanceAmount: newCs.AdvanceAmount,
      BalanceAmount: newCs.BalanceAmount,
      CurrAddStreet: newCs.CurrAddStreet,
      Area: newCs.Area,
      Area: newCs.Area,
      PerAddTown: newCs.PerAddTown,
      City: newCs.City,
      CurrAddState: newCs.CurrAddState,
      CurrAddPincode: newCs.CurrAddPincode,
      PerAddStreet: newCs.PerAddStreet,
      PerAddTown: newCs.PerAddTown,
      PerAddState: newCs.PerAddState,
      PerAddPincode: newCs.PerAddPincode,
      Country: newCs.Country,
      PerAddCountry: "",
      AadharNo: newCs.AadharNo,
      Discount: newCs.Discount,
      CreditPeriod: newCs.CreditPeriod,
      PanNo: newCs.PanNo,
      FineGold: newCs.FineGold,
      FineSilver: newCs.FineSilver,
      GstNo: newCs.GstNo,
      ClientCode: clientCode,
      VendorId: newCs.VendorId,
      Remark: newCs.Remark,
      AddToVendor: newCs.AddToVendor === "false",

      Id: newCs.oldEntry ? newCs.Id : 0,
    };
    console.log(formData, "formData before sending");
    // if (formData.Mobile.length < 10) {
    //   toast.error("please enter a valid mobile number", {
    //     duration: 3000, // Toast will disappear after 3 seconds
    //     position: "top-center", // Toast displayed in the top-center
    //   });
    // } else {
     
     
      try {
        const response = await fetch(!newCs.oldEntry ? a704 : a710, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (data.Message) {
          // setMessageType("error");
          toast.error(data.Message, {
            duration: 3000, // Toast will disappear after 3 seconds
            position: "top-center", // Position of the toast
          });
          setMessageToShow(data.Message);
          // setShowError(true);
        } else {
          // setMessageType("success");
          // setMessageToShow("Customer Added Successfully");
          toast.success("Customer Added Successfully!", {
            duration: 3000, // Toast will disappear after 3 seconds
            position: "top-center", // Position of the toast
          });
          // setShowError(true);
          fetchAllCustomers();
          setActive("List");

          setNewCs({
            FirstName: "",
            LastName: "",
            MiddleName: "",
            PerAddStreet: "",
            CurrAddStreet: "",
            Area: "",
            Mobile: "",
            Email: "",
            Password: "",
            CustomerLoginId: "",
            DateOfBirth: "",
            PerAddPincode: "",
            Gender: "",
            CustomerSlabId: 0,
            CreditPeriodId: 0,
            RateOfInterestId: 0,
            OnlineStatus: "",
            PerAddTown: "",
            City: "",
            Area: "",
            CurrAddPincode: "",
            CurrAddState: "",
            PerAddTown: "",
            PerAddState: "",
            Country: "",
            PerAddCountry: "",
            GstNo: "",
            PanNo: "",
            AadharNo: "",
            BalanceAmount: "0",
            AdvanceAmount: "0",
            Discount: "0",
            CreditPeriod: "0",
            FineGold: "0",
            FineSilver: "0",
            Remark: "",
            VendorId: 0,
            AddToVendor: false,
            oldEntry: false,
          });
        }
      } catch (error) {
        console.error(error);
        alert("fail");
        alert();
      }


    // }
    setLoading(false);
  };
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    setNewCs({ ...data, oldEntry: true });
    setActive("AddNew");
  };

  useEffect(() => {
    if (newCs.PerAddCountry === "India") {
      setCountryStates(states.IN);
    }
  }, [countryStates]);

  const styles = {
    label: {
      display: "block",
      fontWeight: "bold",
      textAlign: "right", // Right-align the label text
      width: "100%", // Full width for consistent spacing
    },
    input: {
      width: "100%", // Full width to make inputs the same size
      padding: "8px",
      boxSizing: "border-box", // Include padding in width calculation
    },
  };

  const handleReset = () => {
    setNewCs({
      FirstName: "",
      LastName: "",
      MiddleName: "",
      PerAddStreet: "",
      CurrAddStreet: "",
      Area: "",
      Mobile: "",
      Email: "",
      Password: "",
      CustomerLoginId: "",
      DateOfBirth: "",
      PerAddPincode: "",
      Gender: "",
      CustomerSlabId: 0,
      CreditPeriodId: 0,
      RateOfInterestId: 0,
      OnlineStatus: "",
      PerAddTown: "",
      City: "",
      Area: "",
      CurrAddPincode: "",
      CurrAddState: "",
      PerAddTown: "",
      PerAddState: "",
      Country: "India",
      PerAddCountry: "India",
      GstNo: "",
      PanNo: "",
      AadharNo: "",
      BalanceAmount: "0",
      AdvanceAmount: "0",
      Discount: "0",
      CreditPeriod: "0",
      FineGold: "0",
      FineSilver: "0",
      Remark: "",
      VendorId: 0,
      AddToVendor: false,
      oldEntry: false,
    });
  };

  const handleList = () => {
    // Custom logic for the List button

    setActive("List");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "LastName", label: "Company Name", type: "read", priority: 1 },

    { key: "FirstName", label: "Customer Name", type: "read", priority: 3 },
    { key: "Mobile", label: "Mobile", type: "read", priority: 4 },
    { key: "Email", label: "Email", type: "read", priority: 5 },
    { key: "BalanceAmount", label: "BalanceAmount", type: "read", priority: 6 },

    {
      key: "AdvanceAmount",
      label: "Advance Amount",
      type: "read",
      priority: 7,
    },
    { key: "GstNo", label: "GST No", type: "read", priority: 8 },
    { key: "CustomerSlab", label: "Customer Slab", type: "read", priority: 9 },
    {
      key: "RateOfInterest",
      label: "Rate of Interest",
      type: "read",
      priority: 10,
    },
    {
      key: "CreditPeriodId",
      label: "Credit period",
      type: "read",
      priority: 11,
    },
  ];

  const filteredData = allCustomersData.filter((customer) =>
    columns.some((column) =>
      customer[column.key]
        ?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );

  const handlenew = () => {
    setActive("AddNew");
  };

  // GST validation state
  const [gstValid, setGstValid] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isGstActive, setIsGstActive] = useState(true); // Track if GST is active

  const handleGSTValidation = async () => {
    if (newCs.GstNo.length === 15) {
    
        try {
          // checking IRN createEinvoiceAndWayBill function it jsut checking --------------
          // console.log("Fetching IRN and EInvoice...");
          // const invoiceData = {
          //   Gstin: newCs.GstNo,
          //   InvoiceNumber: "INV123456",
          //   InvoiceDate: "2023-10-01",
          //   // Add other required fields
          // };

          // const types = ["IRN"];
          // const credentials = {
          //   apiKey: "665b60ad-2b2a-4bd7-bde2-ab106e624c57",
          //   clientId: "IRIS3a3621512a4af7b2b0cb390ca6a4877a",
          //   clientSecret: "d6c6902af5a18966075c4562386d9a2c",
          //   userName: "Irisonyx_mh",
          //   password: "Irisonyxmh_01",
          //   // gstin: newCs.GstNo,
          //   gstin: "27AAACI9260R002",
          // };

          // const results = await createEinvoiceAndWayBill(
          //   types,
          //   invoiceData,
          //   credentials
          // );

          // console.log("Results:", results);
          // console.log("IRN Response:", results.IRN);
          // console.log("E-Invoice Response:", results.EInvoice);

          // checking IRN createEinvoiceAndWayBill function it jsut checking --------------

          const result = await verifyGST(newCs.GstNo);
          if (result.status_code === 1 && result.gstin === newCs.GstNo) {
            const gstStatus = result?.status?.trim().toLowerCase();
            setGstValid(true);
            setIsGstActive(gstStatus === "active");
            toast.success("GST number is valid");

            if (gstStatus === "active") {
              toast.success("GST status is Active");
            } else {
              toast.error(
                `GST status is not Active (Status: ${result.status})`
              );
            }

            const extractedPan = newCs.GstNo.slice(2, 12);
            setNewCs((prev) => ({
              ...prev,
              FirstName: result.tradename || prev.FirstName,
              LastName: result.name || prev.LastName,
              PerAddStreet: result.pradr?.st || prev.PerAddStreet,
              CurrAddStreet: result.pradr?.st || prev.CurrAddStreet,
              CurrAddState: result.pradr?.stcd || prev.CurrAddState,
              CurrAddPincode: result.pradr?.pncd || prev.CurrAddPincode,
              Country: "India",
              PanNo: extractedPan || prev.PanNo,
              Area: result.pradr?.loc || prev.Area,
              City: result.pradr?.district || prev.City,
              Remark: result.constitution || prev.Remark,
              GstStatus: result.status || prev.GstStatus,
            }));
            setIsReadOnly(true);
          } else {
            setGstValid(false);
            setIsGstActive(false);
            toast.error("Invalid GST number or mismatch with API response");
            setIsReadOnly(false);
          }
        } catch (error) {
          setGstValid(false);
          setIsGstActive(false);
          toast.error("Error verifying GST number");
          setIsReadOnly(false);
        }
     
    } else {
      setIsReadOnly(false);
      setIsGstActive(true);
    }
  };

  useEffect(() => {
    handleGSTValidation();
  }, [newCs.GstNo]);

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Customer"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"Customers"}
        />
      </div>

      <div style={{ padding: "16px" }}>
        {active == "List" ? (
          <>
            <div className={style["white-space"]}>
              <div className={style["icon-div"]}>
                <div className={style["search-container"]}>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    className={style["serach-input"]}
                  />
                  <button
                    style={{ margin: 0 }}
                    className={style["search-btn"]}
                    // onClick={handleSearchSubmit}
                  >
                    <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                  </button>
                </div>

                <Icon
                  style={{
                    fontSize: "28px ",
                    color: "#0077d4",
                    cursor: "pointer",
                  }}
                  icon="bx:export"
                />

                <button
                  onClick={handlenew}
                  style={{ margin: 0 }}
                  className={style["custom-btn"]}
                >
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
              </div>
            </div>

            <Customertable
              columns={columns}
              allCategories={allCustomersData}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <form style={{ width: "100%" }} onSubmit={addnewCs}>
                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,2fr)",
                      columnGap: "30px",
                      margin: "0px 0px",
                      padding: "var(--Space-0, 0px) 24px",
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                    <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      className={style.adminCategoryHeading}
                      id="adminInvoiceAddedCustomerEdit"
                    >
                      Customer profile
                    </h2>
                    <Box sx={{ width: "95%", margin: "0 auto" }}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>
                          Name <sup> *</sup>
                        </label>
                        <input
                          // style={{ width: "20vw" }}
                          type="text"
                          name="FirstName"
                          required="required"
                          value={newCs.FirstName}
                          onChange={handleNewCsChange}
                          list="customerNamesList"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                          readOnly={isReadOnly} // Make field read-only based on state
                        />

                        <label>Company Name</label>
                        <input
                          // style={{ width: "20vw" }}
                          type="text"
                          name="LastName"
                          value={newCs.LastName}
                          onChange={handleNewCsChange}
                          list="customerNamesList"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                          readOnly={isReadOnly} // Make field read-only based on state
                        />
                        <datalist id="customerNamesList">
                          {allCustomersData.map((customer) => (
                            <option
                              key={customer.Id}
                              value={`${customer.FirstName} ${customer.LastName}`}
                            />
                          ))}
                        </datalist>

                        <datalist id="customerNamesList">
                          {allCustomersData.map((customer) => (
                            <option
                              key={customer.Id}
                              value={`${customer.FirstName} ${customer.LastName}`}
                            />
                          ))}
                        </datalist>

                        <label>Email</label>
                        <input
                          name="Email"
                          value={newCs.Email}
                          // required="required"
                          onChange={handleNewCsChange}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        />
                        {/* <label>
                          Mobile <sup> *</sup>
                        </label>
                        <input
                          // style={{ width: "20vw" }}
                          type="text"
                          required="required"
                          name="Mobile"
                          value={newCs.Mobile}
                          onChange={handleNewCsChange}
                          list="customerMobilesList"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        /> */}

                        <label>Mobile</label>
                        <input
                          type="text"
                          // required
                          name="Mobile"
                          value={newCs.Mobile}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              handleNewCsChange(e); // Only update state if the value matches the regex
                            }
                          }}
                          list="customerMobilesList"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        />

                        {/* <label>Aadhar Number</label>
                        <input
                          name="AadharNo"
                          value={newCs.AadharNo}
                          onChange={handleNewCsChange}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        /> */}

                        <label>Aadhar Number</label>
                        <input
                          name="AadharNo"
                          value={newCs.AadharNo}
                          onChange={(e) => {
                            // Allow only digits and restrict to 12 characters
                            const filteredValue = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 12);
                            handleNewCsChange({
                              target: {
                                name: "AadharNo",
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        />

                        {/* <label>Pan Number</label>
                        <input
                          name="PanNo"
                          value={newCs.PanNo}
                          onChange={handleNewCsChange}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        /> */}

                        <label>PAN Number</label>
                        <input
                          name="PanNo"
                          value={newCs.PanNo}
                          onChange={(e) => {
                            // Filter and format value to match PAN requirements
                            const filteredValue = e.target.value
                              .toUpperCase() // Convert to uppercase
                              .replace(/[^A-Z0-9]/g, "") // Allow only uppercase alphabets and digits
                              .slice(0, 10); // Limit to 10 characters
                            handleNewCsChange({
                              target: { name: "PanNo", value: filteredValue },
                            });
                          }}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                          readOnly={isReadOnly}
                        />

                        {/* <label>GST Number</label>
                        <input
                          name="GstNo"
                          value={newCs.GstNo}
                          onChange={handleNewCsChange}
                          type="text"
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        /> */}

                        <label>GST Number</label>
                        <input
                          name="GstNo"
                          value={newCs.GstNo}
                          onChange={(e) => {
                            // Filter and format value to match GST requirements
                            const filteredValue = e.target.value
                              .toUpperCase() // Convert to uppercase
                              .replace(/[^A-Z0-9]/g, "") // Allow only uppercase alphabets and digits
                              .slice(0, 15); // Limit to 15 characters
                            handleNewCsChange({
                              target: { name: "GstNo", value: filteredValue },
                            });
                          }}
                          type="text"
                          style={{
                            border: `1px solid ${
                              gstValid === false
                                ? "red"
                                : gstValid === true
                                ? "green"
                                : "#ccc"
                            }`,
                          }}
                          className={style.AddCustomerInput}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        />
                      </div>
                    </Box>
                    <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      id="adminInvoiceAddedCustomerEdit"
                      className={style.adminCategoryHeading}
                    >
                      Additional Details
                    </h2>

                    <Box sx={{ width: "95%", margin: "0 auto" }}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>Customer Slab</label>
                        <select
                          // required="required"
                          type="text"
                          name="CustomerSlabId"
                          value={newCs.CustomerSlabId}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" , width: '95%'}}
                          className={style.AddCustomerSelect}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        >
                          <option value="">Select Customer Slab</option>
                          {customerSlabList.map((slab, index) => (
                            <option key={index} value={slab.Id}>
                              {slab.CustomerSlabName}
                            </option>
                          ))}
                        </select>
                        <label> Rate Of Interest</label>
                        <select
                          // required="required"
                          type="text"
                          name="RateOfInterestId"
                          value={newCs.RateOfInterestId}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc", width: "95%" }}
                          className={style.AddCustomerSelect}
                          ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        >
                          <option value="">
                            Select Customer Rate Of Interest
                          </option>
                          {customerRateOfInterestList.map((slab, index) => (
                            <option key={index} value={slab.Id}>
                              {slab.RateOfInterest}
                            </option>
                          ))}
                        </select>
                        <label>Customer Credit Period</label>
                        <select
                          // required="required"
                          type="text"
                          name="CreditPeriodId"
                          value={newCs.CreditPeriodId}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc", width: "95%" }}
                          className={style.AddCustomerSelect}
                          ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        >
                          <option value="">
                            Select Customer Credit Period
                          </option>
                          {customerCreditPeriodList.map((credit, index) => (
                            <option key={index} value={credit.Id}>
                              {credit.CreditPeriod}
                            </option>
                          ))}
                        </select>
                        {/* <label>Discount (Percentage)</label>
                        <input
                          name="Discount"
                          value={newCs.Discount}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef13}
                          onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                        /> */}

                        <label>Discount (Percentage)</label>
                        <input
                          name="Discount"
                          value={newCs.Discount}
                          onChange={(e) => {
                            // Allow only numeric values
                            const filteredValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ); // Remove any non-numeric characters
                            handleNewCsChange({
                              target: {
                                name: "Discount",
                                value: filteredValue,
                              },
                            });
                          }}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        />

                        {/* <label>Advance Amount</label>
                        <input
                          name="AdvanceAmount"
                          value={newCs.AdvanceAmount}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        /> */}

                        <label>Advance Amount</label>
                        <input
                          name="AdvanceAmount"
                          value={newCs.AdvanceAmount}
                          onChange={(e) => {
                            // Allow only numeric values
                            const filteredValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ); // Remove any non-numeric characters
                            handleNewCsChange({
                              target: {
                                name: "AdvanceAmount",
                                value: filteredValue,
                              },
                            });
                          }}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        />

                        <label>Balance Amount</label>
                        <input
                          name="BalanceAmount"
                          value={newCs.BalanceAmount}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="number"
                          ref={inputRef13}
                          onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                        />

                        <label>Fine Gold</label>
                        <input
                          name="FineGold"
                          value={newCs.FineGold}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="number"
                          ref={inputRef14}
                          onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                        />
                        <label>Fine Silver</label>
                        <input
                          name="FineSilver"
                          value={newCs.FineSilver}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="number"
                          ref={inputRef15}
                          onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                        />
                        <label>Add To Vendor</label>
                        <select
                          name="AddToVendor"
                          value={newCs.AddToVendor}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc", width: "95%" }}
                          className={style.AddCustomerSelect}
                          type="text"
                          required="required"
                          ref={inputRef16}
                          onKeyDown={(e) => handleKeyPress(e, inputRef17)}
                        >
                          <option value={false}>NO</option>
                          <option value={true}>YES</option>
                        </select>
                        <label>Remark</label>
                        <input
                          name="Remark"
                          value={newCs.Remark}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef17}
                          onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                        />
                      </div>
                    </Box>

                    <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      id="adminInvoiceAddedCustomerEdit"
                      // className="adminInvoiceAddTitles"
                      className={style.adminCategoryHeading}
                    >
                      Address Details
                    </h2>

                    <Box sx={{ width: "95%", margin: "0 auto" }}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>Street</label>
                        <input
                          name="CurrAddStreet"
                          value={newCs.CurrAddStreet}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef18}
                          onKeyDown={(e) => handleKeyPress(e, inputRef19)}
                          readOnly={isReadOnly} // Make field read-only based on state
                        />
                        <label>Area</label>
                        <input
                          name="Area"
                          value={newCs.Area}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef19}
                          onKeyDown={(e) => handleKeyPress(e, inputRef20)}
                        />
                        <label>Town</label>
                        <input
                          name="PerAddTown"
                          value={newCs.PerAddTown}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef20}
                          onKeyDown={(e) => handleKeyPress(e, inputRef21)}
                        />
                        <label>City</label>
                        <input
                          name="City"
                          value={newCs.City}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          ref={inputRef22}
                          onKeyDown={(e) => handleKeyPress(e, inputRef23)}
                        />
                        <label>
                          Country <sup>*</sup>
                        </label>
                        <select
                          name="Country"
                          value={newCs.Country}
                          className={style.AddCustomerSelect}
                          style={{ border: "1px solid #ccc", width: "95%" }}
                          onChange={handleNewCsChange}
                          required="required"
                          ref={inputRef23}
                          onKeyDown={(e) => handleKeyPress(e, inputRef24)}
                        >
                          {allCountriesList.map((x, y) => (
                            <option key={y} value={x}>
                              {x}
                            </option>
                          ))}
                        </select>
                        <label>
                          State <sup> *</sup>
                        </label>

                        {/* <input
                          name="CurrAddState"
                          value={newCs.CurrAddState}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc" }}
                          className={style.AddCustomerInput}
                          type="text"
                          required="required"
                          list="CurrAddState"
                          ref={inputRef25}
                          onKeyDown={(e) => handleKeyPress(e, inputRef26)}
                        />
                        <datalist id="CurrAddState">
                          {countryStates.map((x, index) => (
                            <option key={index} value={x}>
                              {x}
                            </option>
                          ))}
                        </datalist> */}

                        <select
                          name="CurrAddState"
                          value={newCs.CurrAddState}
                          onChange={handleNewCsChange}
                          style={{ border: "1px solid #ccc", width: "95%" }}
                          className={style.AddCustomerInput}
                          ref={inputRef25}
                          onKeyDown={(e) => handleKeyPress(e, inputRef26)}
                          required
                          readOnly={isReadOnly} // Make field read-only based on state
                        >
                          <option value="" disabled>
                            Select
                          </option>
                          {countryStates.map((state, index) => (
                            <option key={index} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>

                        <label>Pincode</label>
                        <input
                          name="CurrAddPincode"
                          value={newCs.CurrAddPincode}
                          className={style.AddCustomerInput}
                          style={{ border: "1px solid #ccc" }}
                          onChange={handleNewCsChange}
                          type="number"
                          ref={inputRef26}
                          onKeyDown={(e) => handleKeyPress(e, null)}
                          readOnly={isReadOnly} // Make field read-only based on state
                        />
                      </div>
                    </Box>
                  </div>

                  {!loading ? (
                    <>
                      <div className={style["btn-container"]}>
                        <button
                          className={style.buttons}
                          type="submit" // Change back to "submit" to work with the form
                          onClick={(e) => {
                            e.preventDefault(); // Prevent default form submission
                            if (newCs.GstNo && !isGstActive) {
                              toast.error(
                                "Please update the GST number you provided or remove it."
                              );
                            } else if (!loading) {
                              addnewCs(e); // Pass the event object to addnewCs
                            }
                          }}
                          style={{
                            backgroundColor:
                              (newCs.GstNo && !isGstActive) || loading
                                ? "#ccc" // Gray background for disabled state
                                : "#0077d4", // Default background color
                            color:
                              (newCs.GstNo && !isGstActive) || loading
                                ? "#666" // Gray text for disabled state
                                : "#fff", // Default text color
                            cursor:
                              (newCs.GstNo && !isGstActive) || loading
                                ? "not-allowed" // Show not-allowed cursor for disabled state
                                : "pointer", // Default cursor
                          }}
                        >
                          <Icon
                            icon="ic:baseline-check"
                            width="24"
                            height="24"
                          />{" "}
                          Submit
                        </button>
                        <button
                          className={style.buttons}
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: "#0077d4" }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                        <button
                          className={style.buttons}
                          type="button"
                          onClick={handleList}
                        >
                          <Icon
                            icon="fluent:list-rtl-16-filled"
                            width="24"
                            height="24"
                          />
                          List
                        </button>
                      </div>
                    </>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
